import type { DiTypes } from "@iot-platform/core";

export const reportTypes = Object.seal({
    repositories: {
        ReportRepository: Symbol.for("ReportRepository"),
    },
} satisfies DiTypes);
